import {
    DocumentEditorContainer
} from "../../CreateOrEditEditorComponent";

export const openSelectionsNav = (
  setSelectionsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setSignaturesOpen: React.Dispatch<React.SetStateAction<boolean>>,
  containerRef: React.RefObject<DocumentEditorContainer | null>
) => {
  setSignaturesOpen(false);
  if (containerRef.current) {
      containerRef.current.showPropertiesPane = false;
  }
  setSelectionsOpen(true);
};

export const closeSelectionsNav = (setSelectionsOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  setSelectionsOpen(false);
};
